<template>

  <Recessi />

</template>

<script>
import Recessi from '../components/pratiche/CheckRecessi.vue'

export default {
  components: {
    Recessi

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
